import React from 'react';
import ListComponent from "./ListComponent";
import WindowLocation from "../Services/WindowLocation";
import Pagination from "../Design/Pagination";
import LoadMore from "../Design/LoadMore";
import DesignComponent from "../Design/DesignComponent";
import PostList from "../Design/PostList";
import Navigation from "../Design/Navigation";
import Input from "../Design/Input";
import Button from "../Design/Button";

export default class Post extends ListComponent {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isOpenFilter: false
        };

        this.perPage = this.config.per_page;
        this.querySearchTimeOut = null;
        this.orderDate = null;

        this.refFilter = React.createRef();
        this.refSearch = React.createRef();
        this.refFilterDiv = React.createRef();

        this.openFilter = this.openFilter.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.clearAll = this.clearAll.bind(this);

        this.handleType = this.handleType.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleButton = this.handleButton.bind(this);
    }

    componentDidMount() {
        if (!window.location.getHashObj) {
            WindowLocation.getWindowLocation();
        }

        if (this.config && this.config.params) {
            Object.values(this.config.params).map(param => {
                if (window.location.getHashObj(param.key)) {
                    if (param.render.type === 'checkbox' && typeof window.location.getHashObj(param.key) === 'string') {
                        window.location.addHash(param.key, [window.location.getHashObj(param.key)]);
                    }
                }

                if (param.key === 'order-date') {
                    const {
                        0: $keyValue,
                        1: $objValue
                    } = Object.entries(param.render.values).find(([k, v]) => v.value === param.default);
                    this.orderDate = $objValue;
                }
            });
        }

        super.componentDidMount();
    }

    openFilter() {
        this.setState({
            isOpenFilter: !this.state.isOpenFilter
        }, () => {
            if (this.state.isOpenFilter) {
                this.toggleElement(this.refFilter)
                this.scrollEvent(this.refFilter)
            }
        });
    }

    clearAll() {
        this.resetParams(() => {
            if (this.refSearch && this.refSearch.current) {
                this.refSearch.current.value = '';
            }

            this.clearSearch()
        });
    }

    clearSearch() {
        window.location.removeHash('s');

        this.updateParams('s', null);
        if (this.refSearch && this.refSearch.current) {
            this.refSearch.current.value = '';
        }

        WindowLocation.rewriteUrl();
    }

    handleCheckbox(key, value) {
        const {state: {params}} = this;
        let sections = params[key] ?? null;

        if (!sections) {
            sections = [value.value];
        } else {
            let checked = sections.indexOf(value.value);

            if (checked > -1) {
                sections = sections.filter((section, index) => index !== checked);
            } else {
                if (typeof sections === "string") {
                    sections = [sections];
                }

                sections = [...sections, value.value];
            }
        }

        this.updateParams(key, (sections && sections.length > 0) ? sections : null);

        if (sections !== null && sections.length > 0) {
            window.location.addHash(key, sections);
        } else {
            window.location.removeHash(key);
        }

        WindowLocation.rewriteUrl();
    }

    handleType(type) {
        const {value, slug, source} = type;
        this.type = type;
        super.resetParams(() => {
            const {params: {type: {key}}} = this.config;

            this.source = source;

            window.location.removeHash('page');
            window.location.removeHash('s');

            if (slug) {
                window.location.addHash(key, slug);
            } else if (null === slug && window.location.getHashObj(key)) {
                window.location.removeHash(key);
            }

            WindowLocation.rewriteUrl();

            this.updateParams(key, slug);
        });
    }

    handleSearch(event) {
        const {currentTarget: {value: search}, nativeEvent} = event;
        if (nativeEvent.type === 'submit') {
            event.preventDefault();
            return;
        }

        if (this.querySearchTimeOut) {
            clearTimeout(this.querySearchTimeOut);
        }

        this.querySearchTimeOut = setTimeout(() => {
            if (search) {
                window.location.addHash('s', search);
            } else {
                window.location.removeHash('s');
            }

            this.updateParams('s', search);
            WindowLocation.rewriteUrl();
        }, 1000);
    }

    handleButton(param) {
        const {key, default: defaultValue, render: {values}} = param;
        const {state: {params: {[key]: value}}} = this;
        let $value = value;

        if (!$value) {
            $value = defaultValue;
        }

        const {0: $keyValue, 1: $objValue} = Object.entries(values).find(([k, v]) => v.value === $value);
        const next$Value = parseInt($keyValue) < Object.values(values).length - 1 ? parseInt($keyValue) + 1 : 0;
        this.orderDate = values[next$Value];

        this.updateParams(key, this.orderDate.value);

        if (this.orderDate.value) {
            window.location.addHash(key, this.orderDate.value);
        } else {
            window.location.removeHash(key);
        }

        WindowLocation.rewriteUrl();
    }

    render() {
        const {
            page,
            state: {list, loaded, totalPages, params: activeParams, isOpenFilter, totalPosts},
            config: {params, heading: headingParam, messageNotFound, pagination},
            isPagination,
            isLoadMore,
            orderDate
        } = this;

        let isActiveParams = false;
        for (let index in activeParams) {
            if (!activeParams.hasOwnProperty(index)) {
                continue;
            }

            isActiveParams = (!!activeParams[index] || (activeParams[index] !== null && activeParams[index].length !== 0));

            if (isActiveParams) {
                break;
            }
        }

        return <DesignComponent ref={this.refAutoScroll}>

            <form onSubmit={this.handleSearch}>
                <div>
                    <label>
                        <input type="text" placeholder="Search insight" onKeyUp={this.handleSearch} ref={this.refSearch}
                               defaultValue={activeParams.s ?? undefined}/>
                    </label>
                    <button type="button"><span>Search</span></button>
                </div>
            </form>

            <div className="filter">
                <div className="wrapper">
                    {params && params.type && params.type.render &&
                        <Navigation links={params.type.render.values} onClick={this.handleType}
                                    active={activeParams.type}/>}
                </div>
            </div>

            <div className="advanced-filter">
                <div className="wrapper">
                    <button className={`advanced-search  ${isOpenFilter ? 'active' : ''}`} onClick={this.openFilter}
                            type="button">
                        <span>{this.config.hasOwnProperty('advanceSearch') && this.config.advanceSearch.hasOwnProperty('label') ? this.config.advanceSearch.label : 'Advanced Search'}</span>
                    </button>

                    {params && Object.entries(params).map(([key, param]) => (param.render && param.render !== false && param.app && param.app === 'Button') ?
                        <Button name={param.key}
                                label={`${param.render.label && param.render.label} ${(orderDate && orderDate.label) ? orderDate.label : ''}`}
                                className={`${param.key}-${activeParams[param.key]}`}
                                onClick={() => {
                                    this.handleButton(param);
                                }}/> : null)}

                    <div className="active-filters">

                        {activeParams['s'] && <div className={'item'}>
                            <button type={'button'} onClick={event => {
                                event.preventDefault();
                                this.clearSearch()
                            }}>
                                <span className="screen-reader-text">remove</span>
                                {activeParams['s']}
                            </button>

                        </div>}
                        {params && Object.values(params).map(param => param.render.values && param.render.values.map(p => ['order-date', 'type'].indexOf(param.key) < 0 && activeParams[param.key] && activeParams[param.key].indexOf(p.value) > -1 &&
                            <div className={'item'}>
                                <button type="button" onClick={event => {
                                    event.preventDefault();
                                    this.handleCheckbox(param.key, p)
                                }}>
                                    <span dangerouslySetInnerHTML={{__html: p.label}}/>
                                </button>
                            </div>))}
                    </div>

                    <DesignComponent ref={this.refFilter}>
                        <div className={`filters totoggle ${isOpenFilter ? 'active' : ''}`} style={{display : 'none'}} ref={this.refFilterDiv}>
                            <div className={'inner'} key={'filter-inner-data'}>
                                {params && Object.entries(params).map(([key, param]) => (param.render && param.render !== false && param.app && param.app === 'Input') ?
                                    <Input name={param.key}
                                           options={param.render.values}
                                           values={activeParams[param.key]}
                                           label={param.render.label}
                                           type={param.render.type ?? 'checkbox'}
                                           onChange={(val) => this.handleCheckbox(param.key, val, param.render.type ?? 'checkbox')}/> : null)}
                                <button className="close" type="button" onClick={this.openFilter}><span>Close</span>
                                </button>

                                {window.location.hashObj !== false &&
                                    <button type={"button"} onClick={this.clearAll} className={'clear'}>
                                        <span>Clear All</span>
                                    </button>}
                            </div>
                        </div>
                    </DesignComponent>


                </div>
            </div>

            <PostList post={list} messageNotFound={messageNotFound} className={`${loaded ? '' : 'loading'}`}
                      dataKey={'fp-post'} key={'fp-post'}
                      backgroundListColors={this.config.hasOwnProperty('backgroundListColors') ? this.config.backgroundListColors : []}/>

            {loaded && list && Object.values(list).length < 1 && <p>{messageNotFound}</p>}

            {(!loaded || (window.location.getHashObj && window.location.getHashObj('debug'))) &&
                <div className={"load-more-container dynamic-loading"}>
                    <div className={"fp-loading"}><span/><br/> Loading</div>
                </div>}

            {(isLoadMore && loaded && page < totalPages) && <LoadMore onClick={this.loadMore}/>}

            {(isPagination && totalPages > 0) &&
                <Pagination onClick={this.loadPagination} page={page} totalPage={totalPages} config={pagination}/>}
        </DesignComponent>;
    }
}